import { useEffect, useState } from 'react'

export default function useTableOfContents(deps = []) {
	const [tocItems, setTocItems] = useState([])

	useEffect(() => {
		const elements = Array.from(document.querySelectorAll('h2, h3, h4, h5, h6'))
			.filter(element => element.id)
			.map(element => ({
				url: `#${element.id.replaceAll(',', '')}`, // Sometimes, the id contains a comma for no reasons :| (Gatsby issue?)
				title: element.dataset?.toc ?? element.textContent ?? '',
				depth: Number(element.tagName.substring(1)),
			}))

		const rootItem = { depth: 1, items: [], parent: undefined }
		let currentItem = rootItem

		elements.forEach(element => {
			const item = {
				...element,
				items: [],
			}

			if (element.depth === currentItem.depth) {
				item.parent = currentItem.parent
				currentItem.parent.items.push(item)
			} else if (element.depth > currentItem.depth) {
				item.parent = currentItem
				currentItem.items.push(item)
			} else if (element.depth < currentItem.depth) {
				let parent = currentItem.parent
				while (parent && element.depth <= parent.depth) {
					parent = parent.parent
				}

				item.parent = parent
				parent.items.push(item)
			}

			currentItem = item
		})

		setTocItems(rootItem.items)
	}, deps)

	return tocItems
}
